import {
    $,
    $$,
    createElement,
    createSpinner,
    empty,
    getParentElementByClassName,
    html_chargement_en_cours,
} from "./Dom.ts";
import {$get, $post, $postForm} from "./Ajax.ts";
import {fadeOut, fadeOutFadeIn} from "./Animate.ts";
import {createErrorNotification, createSuccessNotification} from "../../portail/js/Notifications.ts";
import {generateModale} from "./Modal.ts";
import {findCkeditorInstance} from "./Utils.ts";
import {initTooltips} from "./Tooltip.ts";


export function initMessageListeners(archive: boolean) {
    afficherDate()
    $$<HTMLElement>('.title_msg').forEach(element => {
        element.addEventListener('click', () => {
            toggleMessageBody(element, archive)
        })
        element.addEventListener('keyup', (event) => {
            if ((event.type === "keyup" && (event.code === "Enter" || event.code === "NumpadEnter"))) {
                element.click()
            }
        })
    })
}

const createDateElement = (date: string) => {
    const container = createElement('p', ['date_msg'])
    const dateElement = createElement('span')
    dateElement.innerText = date
    container.appendChild(dateElement)
    return container
}
export const afficherDate = () => {
    const listeDesMessages = $$<HTMLElement>('.title_msg');
    let ancien = '';
    for (const message of listeDesMessages) {
        let date = message.dataset.date
        if (date && date !== ancien) {
            const dateElement = createDateElement(date)
            message.parentElement?.parentElement?.insertBefore(dateElement, message.parentElement)
            ancien = date
        }
    }
}

export const toggleMessageBody = (element: HTMLElement, archive: boolean) => {
    const pk = element.dataset.pk
    const body = $<HTMLElement>(`#body_${pk}`)
    if (body && pk) {
        if (element.getAttribute('aria-expanded') === "false") {
            cleanAllMessage()
            showMessageBody(pk, element, body, archive)
        }
    }
}

function cleanAllMessage() {
    $$<HTMLElement>('.message_body').forEach(element => element.innerHTML = "")
}

function showMessageBody(pk: string, title: HTMLElement, body: HTMLElement, archive: boolean) {
    body.innerHTML = ""
    const spinner = html_chargement_en_cours()
    body.appendChild(spinner)
    let url_msg = "/messagerie/message/" + pk;
    if (archive) {
        url_msg = "/messagerie/messagearchive/" + pk;
    }
    title.style.fontWeight = 'normal'
    $get(url_msg).then((data) => {
        body.innerHTML = data.body
        // ici on envoi à django le fait que l'utilisateur à lu le message.
        const url = "/messagerie/lu/?msg=" + pk
        $post(url)
        initMessageListener()
        initTooltips(body)
    });
}

function initMessageListener() {
    $('#nonlu_msg')?.addEventListener('click', mettreMessageEnNonLu)
    $("#notification_immediate")?.addEventListener('click', notificationImmediate)
    $('#open-in-window')?.addEventListener('click', ouvrirEnPleinEcran)
    $('#repondre_affiche')?.addEventListener('click', afficherRepondreAuMessage)
    $('#get_email_statut')?.addEventListener('click', afficherStatutEmails)
}

function mettreMessageEnNonLu() {
    const target = $<HTMLElement>('#nonlu_msg')
    const url = target?.dataset?.url
    if (url) {
        $post(url).then(() => {
            const body = getParentElementByClassName(target, 'message_body')
            if (body) {
                const title = $<HTMLElement>(`[aria-controls="${body.id}"]`)
                if (title) {
                    title.click()
                    title.style.fontWeight = 'bold'
                }
            }
        })
    }
}

function notificationImmediate() {
    const target = $<HTMLElement>('#notification_immediate')
    const url = target?.dataset?.url
    if (url) {
        $get(url).then(() => {
            const body = getParentElementByClassName(target, 'message_body')
            if (body) {
                const title = $<HTMLElement>(`[aria-controls="${body.id}"]`)
                if (title) {
                    title.click()
                }
            }
        })
    }
}


function ouvrirEnPleinEcran() {
    const target = $<HTMLElement>('#open-in-window')
    const url = target?.dataset?.url
    if (url) window.open(url, '_blank')?.focus();
}

function afficherRepondreAuMessage(event: DOMEvent<HTMLElement>) {
    const pk = event.target.dataset.pk
    const spinner = createSpinner()
    event.target.prepend(spinner)
    $get(window.Openscop.url_messagerie_envoi_message_reponse, {pk}).then((reponse) => {
        const responseContainer = $<HTMLElement>('#envoi_reponse_div')
        if (responseContainer) {
            responseContainer.innerHTML = reponse.body
            spinner.remove()
            fadeOutFadeIn(event.target, responseContainer)
            $('#formmail_rep')?.addEventListener('submit', envoyerReponse)
        }
    })
}

function afficherStatutEmails() {
    const target = $<HTMLElement>('#get_email_statut')
    const url = target?.dataset?.url
    if (url) {
        $get(url).then((result) => {
            const result_html = createElement('div')
            result_html.innerHTML = result.body
            generateModale('statut-email-associe', {title: 'Statut des emails liés', content: result_html})
        })
    }
}

function envoyerReponse(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.target)
    const corps = $<HTMLInputElement>("#id_corps")
    const messageObject = $<HTMLInputElement>('#msg_objet')
    if (corps && messageObject) {
        data.set('corps', findCkeditorInstance(event.target.elements['corps'].id).getData())
        if (data.get("objet") === "") {
            messageObject.style.border = "red 1px solid"
        } else {
            envoyer_le_mail(data);
        }
    }
}

function envoyer_le_mail(data: FormData) {
    // fixme: django a une erreur a verifier quand ca sera fix
    const url = window.Openscop.url_messagerie_envoi_message_reponse + "?pk=" + data.get('reponsepk')
    $postForm(url, data).then((response) => {
        if (response.response.ok) {
            createSuccessNotification({message: "Message envoyé"})
            const container = $<HTMLElement>('#envoi_reponse_div')
            if (container) {
                fadeOut(container)
                empty(container)
            }
            $<HTMLElement>('#show_mail')?.click();
        } else if (response.response.status === 403) {
            createErrorNotification({message: "Format de fichier non autorisé"})
        } else {
            createErrorNotification({message: "Erreur d'envoi du message"})
        }
    })
}